import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { List, Map } from 'immutable';
import { AutoSizer, Column, Table } from 'react-virtualized';
import immutableCreatorSelector from '../../../selectors/immutableCreatorSelector';
import { currentProjectIdSelector } from '../../../reducers/projects';
import { buildFlatListNew } from '../../../reducers/views';
import {
  elementsSelector,
  filterElementsByType,
} from '../../../reducers/elements';
import {
  taskTypeIdSelector,
  milestoneTypeIdSelector,
} from '../../../reducers/elementTypes';
import {
  relationshipsSelector,
  relationshipsByType,
} from '../../../reducers/relationships';
import { wbsRelTypeIdSelector } from '../../../reducers/relationshipTypes';
import { currentUserSelector } from '../../../reducers/users';
import TaskCell from './TaskCell';

const orderedWbsElementsSelector = (state, props) => props.orderedWbsElements;

const tasksSelector = immutableCreatorSelector(
  [
    currentProjectIdSelector,
    orderedWbsElementsSelector,
    elementsSelector,
    taskTypeIdSelector,
    milestoneTypeIdSelector,
    relationshipsSelector,
    wbsRelTypeIdSelector,
    currentUserSelector,
  ],
  (
    currentProjectId,
    orderedWbsElements,
    elements,
    taskTypeId,
    milestoneTypeId,
    relationships,
    wbsRelTypeId,
    currentUser,
  ) => ({
    currentProjectId,
    elements,
    flatList: buildFlatListNew(
      orderedWbsElements,
      elements,
      filterElementsByType(elements, [taskTypeId, milestoneTypeId]),
      relationshipsByType(relationships),
      wbsRelTypeId,
      null,
      null,
      currentUser,
    ).flatList,
  }),
);

@connect(tasksSelector)
export default class AssignTasksList extends Component {
  static propTypes = {
    flatList: PropTypes.instanceOf(List),
    selectedElementId: PropTypes.string,
    existingPredecessors: PropTypes.array,
    elements: PropTypes.instanceOf(Map),
    elementType: PropTypes.instanceOf(Map),
    tasklistCallback: PropTypes.func,
    handleAddRel: PropTypes.func,
  };

  populateFlatList = () => {
    const { flatList, existingPredecessors } = this.props;
    const list = flatList.filter(
      item =>
        item &&
        (item.has('element') === false ||
          existingPredecessors.indexOf(item.getIn(['element', 'id'])) === -1),
    );
    return list;
  };

  handleRowClick = () => {
    const { tasklistCallback } = this.props;
    tasklistCallback();
  };

  render() {
    const {
      elementIds, // for multiEdit
      multiEditElementType, // for multiEdit
      selectedElementId,
      elements,
      elementType,
      tasklistCallback,
      handleAddRel,
    } = this.props;
    const flatList = this.populateFlatList();
    if (!flatList.size) {
      return <div>There are no tasks.</div>;
    }
    const selectedElement = elements.get(selectedElementId);
    // const selectedElementName = selectedElement.get('name');

    return (
      <div
        style={{
          marginRight: 20,
          width: '50%',
        }}
      >
        <div
          className="elements-list"
          style={{ flex: '1 1 auto', height: '100%', minHeight: 400 }}
        >
          <AutoSizer>
            {({ height, width }) => (
              <Table
                disableHeader
                width={width}
                height={height}
                headerHeight={20}
                rowHeight={30}
                rowCount={flatList.size}
                rowGetter={({ index }) => flatList.get(index)}
                rowClassName={({ index }) => {
                  const listItem = flatList.get(index);
                  const elementId = listItem.getIn(['element', 'id'], null);
                  const isSelected =
                    (selectedElement &&
                      selectedElement.get('id') === elementId) ||
                    (elementIds && elementIds.includes(elementId));
                  return isSelected ? 'activeItem' : null;
                }}
                onRowClick={({ rowData }) => {
                  const element = rowData.get('element');
                  if (element) {
                    tasklistCallback(element);
                  }
                }}
              >
                <Column
                  dataKey="name"
                  width={300}
                  flexGrow={1}
                  cellRenderer={({ rowData, rowIndex }) => {
                    const rowElement = rowData.get('element') || rowData;
                    const typeName = elementType && elementType.get('type');

                    return (
                      <TaskCell
                        onClick={event => event.stopPropagation()}
                        rowIndex={rowIndex}
                        currentRowData={rowElement}
                        elementTypeName={typeName || multiEditElementType}
                        callback={tasklistCallback}
                        selectedElementId={selectedElementId}
                        handleAddRel={handleAddRel}
                      />
                    );
                  }}
                />
              </Table>
            )}
          </AutoSizer>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/AssignPredecessorModal/TasksList.js